import { render, staticRenderFns } from "./ListaLotes.vue?vue&type=template&id=18da8870"
import script from "./ListaLotes.vue?vue&type=script&lang=js"
export * from "./ListaLotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports